/**
 * Client-side mirror of the API's CMS validation caps
 * (`saas/apps/api/src/cms/cms.service.ts` — exported there for exactly this
 * purpose). There's no shared package between web/api yet, so these are
 * hand-kept in sync; if the API caps change, update both files together.
 *
 * Used for the editor's `maxLength` attributes and its list-size guard so a
 * Save can't round-trip to a 400 for a cap the editor could have enforced
 * (and shown inline) before ever hitting the network.
 */
export const CMS_MAX_FIELD_LENGTH = 2000;
export const CMS_MAX_LIST_ITEMS = 24;
export const CMS_MAX_ITEM_ARRAY_ENTRIES = 30;
export const CMS_MAX_ITEM_ARRAY_ENTRY_LENGTH = 1000;
